const routes = [
  {
    path: "/purchased-addons",
    name: "PurchasedAddOns",
    component: () => import(/* webpackChunkName: "AppInfo" */ "../addonsPurchased/views/PurchasedAddOns/PurchasedAddOns.vue"),
  },
];
export default routes;
